var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 180 160",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "90",
      "cy": "85",
      "rx": "80",
      "ry": "69",
      "fill": "#EEF0FF"
    }
  }), _c('rect', {
    attrs: {
      "x": "24",
      "y": "85",
      "width": "62",
      "height": "49",
      "rx": "6",
      "fill": "#E6C79A"
    }
  }), _c('path', {
    attrs: {
      "d": "M24 94h62M48 85v20h14V85",
      "stroke": "#C49A64",
      "stroke-width": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "72",
      "y": "35",
      "width": "73",
      "height": "100",
      "rx": "9",
      "fill": "white",
      "stroke": "#8B80D5",
      "stroke-width": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "91",
      "y": "28",
      "width": "35",
      "height": "16",
      "rx": "5",
      "fill": "#4F35BC"
    }
  }), _c('path', {
    attrs: {
      "d": "m84 65 4 4 7-8m-11 24 4 4 7-8",
      "stroke": "#4F35BC",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M104 65h25m-25 20h25",
      "stroke": "#C8C1EA",
      "stroke-width": "4",
      "stroke-linecap": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "137",
      "cy": "121",
      "r": "22",
      "fill": "#4F35BC"
    }
  }), _c('path', {
    attrs: {
      "d": "m130 110 17 11-17 11Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "m38 41 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z",
      "fill": "#AAA1E5"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }